"use client";

import Image from "next/image";
import Link from "./LocaleLink";
import { useLocale } from "./LocaleProvider";

const copy = {
  en: {
    title: "Before & After",
    note: "Results vary by case. Images shown with patient consent.",
    before: "Before",
    after: "After",
    makeover: "Smile makeover",
    cta: "Book a Consultation",
  },
  ro: {
    title: "Înainte și după",
    note: "Rezultatele variază de la caz la caz. Imaginile sunt afișate cu acordul pacienților.",
    before: "Înainte",
    after: "După",
    makeover: "Transformarea zâmbetului",
    cta: "Programează o consultație",
  },
} as const;

type Pair = { before: string; after: string };

const PAIRS: Pair[] = [
  { before: "/before1.jpg", after: "/after1.jpg" },
  { before: "/before2.jpg", after: "/after2.jpg" },
  { before: "/before3.jpg", after: "/after3.jpg" },
  { before: "/before4.jpg", after: "/after4.jpg" },
  { before: "/before5.jpg", after: "/after5.jpg" },
  { before: "/before6.jpg", after: "/after6.jpg" },
];

export default function BeforeAfter() {
  const t = copy[useLocale()];

  return (
    <section className="container-px mx-auto py-8">
      <h2 className="text-center text-xl md:text-2xl font-semibold text-white mb-2">
        {t.title}
      </h2>
      <p className="text-center text-white/60 text-xs mb-6">
        {t.note}
      </p>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 justify-items-center">
        {PAIRS.map((p, i) => (
          <article
            key={i}
            className="w-full max-w-[420px] rounded-lg border border-[#27E8A7]/70 bg-transparent shadow-[0_0_5px_rgba(39,232,167,0.15)]"
          >
            <div className="rounded-[8px] bg-black p-2">
              {/* BEFORE */}
              <figure className="relative overflow-hidden rounded-md aspect-[3/2]">
                <span className="absolute left-1.5 top-1.5 z-10 rounded-full bg-black/70 px-1.5 py-[1px] text-[9px] font-semibold text-white/90 border border-white/10">
                  {t.before}
                </span>
                <Image
                  src={p.before}
                  alt={`${t.makeover} ${i + 1} - ${t.before.toLowerCase()}`}
                  fill
                  className="object-cover rounded-md"
                  sizes="(max-width: 468px) 100vw, 30vw"
                />
              </figure>

              <div className="h-1.5 md:h-2" />

              {/* AFTER */}
              <figure className="relative overflow-hidden rounded-md aspect-[3/2]">
                <span className="absolute left-1.5 top-1.5 z-10 rounded-full bg-[#27E8A7]/80 px-1.5 py-[1px] text-[9px] font-semibold text-black border border-white/10">
                  {t.after}
                </span>
                <Image
                  src={p.after}
                  alt={`${t.makeover} ${i + 1} - ${t.after.toLowerCase()}`}
                  fill
                  className="object-cover rounded-md"
                  sizes="(max-width: 468px) 100vw, 30vw"
                />
              </figure>
            </div>
          </article>
        ))}
      </div>

      <div className="text-center mt-6">
        <Link
          href="/contact"
          className="inline-block rounded-full px-4 py-2 text-xs font-semibold border border-[#27E8A7] text-[#27E8A7] hover:bg-[#27E8A7] hover:text-black transition"
        >
          {t.cta}
        </Link>
      </div>
    </section>
  );
}
